import { takeLatest, put, call } from 'redux-saga/effects';

import { listFuncionarioCargoCadastro } from '../service';
import {
  TABLE_FUNCIONARIO_CARGO_CADASTRO,
  TABLE_FUNCIONARIO_CARGO_CADASTRO_PENDING,
  TABLE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
  TABLE_FUNCIONARIO_CARGO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListFuncionarioCargoCadastro(action) {
  yield put({ type: TABLE_FUNCIONARIO_CARGO_CADASTRO_PENDING })

  try {
    const table = yield call(listFuncionarioCargoCadastro, action.args)
    yield put({ type: TABLE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_FUNCIONARIO_CARGO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListFuncionarioCargoCadastro() {
  yield takeLatest(TABLE_FUNCIONARIO_CARGO_CADASTRO, sagaListFuncionarioCargoCadastro)
}